import { NgModule } from '@angular/core';
import { ContentRendererDirective } from './content-renderer.directive';

@NgModule({
  declarations: [ContentRendererDirective],
  exports: [ContentRendererDirective],
})
export class ContentRendererModule {}
